import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=8ecca49c&"
import script from "./RegionsList.vue?vue&type=script&lang=js&"
export * from "./RegionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports